<template>
  <span v-if="crossed == 1">
    <s>{{first}}{{asterisk}}</s>
    {{separator}}
    <span>{{second}}{{asterisk}}</span>
  </span>
  <span v-else-if="crossed == 2">
    <span>{{first}}{{asterisk}}</span>
    {{separator}}
    <s>{{second}}{{asterisk}}</s>
  </span>
  <span v-else>
    <span>{{first}}{{asterisk}}</span>
    {{separator}}
    <span>{{second}}{{asterisk}}</span>
  </span>
</template>

<script>
export default {
  name: 'w-crossed-out',
  props: {
    crossed: Number,
    separator: {
      type: String,
      default: '/'
    },
    asterisk: {
      type: String,
      default: '*'
    },
    first: String,
    second: String
  },
  data() {
    return {};
  }
};
</script>

<style>
</style>